import { NgModule, LOCALE_ID, ErrorHandler } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import localeNl from '@angular/common/locales/nl';

import { MyHammerConfig } from './utils/hammerjs/hammer.config';

import { VMComponentsErrorHandler } from '../vm_api';
import { CrosscuttingModule } from '@crosscutting/public_api';

import { VMDataService, VeiligheidsMeterService, VMComponentsModule, VMServicesModule } from '../vm_api';

import { CheckComponent } from './stappen/check/check.component';
import { TipsComponent } from './stappen/tips/tips.component';
import { OverzichtComponent } from './stappen/overzicht/overzicht.component';
import { ErrorschermComponent } from './stappen/error/errorscherm.component';
import { SessieVerlopenComponent } from './stappen/sessie-verlopen/sessie-verlopen.component';

import { AppRoutingModule } from './veiligheidsmeter.app-routing.module';
import { AppComponent } from './veiligheidsmeter.app.component';


registerLocaleData(localeNl);

@NgModule({
  imports: [
    CommonModule,
    AppRoutingModule,
    BrowserModule,
    VMComponentsModule.forRoot(),
    VMServicesModule.forRoot(),
    CrosscuttingModule.forRoot()
  ],
  declarations: [
    AppComponent,
    CheckComponent,
    TipsComponent,
    OverzichtComponent,
    SessieVerlopenComponent,
    ErrorschermComponent
  ],
  bootstrap: [
    AppComponent
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: VMComponentsErrorHandler,
    },
    { provide: LOCALE_ID, useValue: 'nl-NL' },
    { provide: HAMMER_GESTURE_CONFIG, useClass: MyHammerConfig },
    VMDataService,
    VeiligheidsMeterService
  ]
})
export class AppModule { }
